/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Select_CountryInputs */



/**
* | output |
* | --- |
* | "Select country" |
*
* @param {Tfield_Select_CountryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_select_country = /** @type {((inputs?: Tfield_Select_CountryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Select_CountryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione país")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecionar país")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona nazione")
	return /** @type {LocalizedString} */ ("Select country")
});